// extracted by mini-css-extract-plugin
export var root = "Circle-module--root--74300";
export var selected = "Circle-module--selected--b5a73";